import {
    EventsType,
    DisplayActions,
    Event,
    EventNames,
    GenericActions,
    OverlayIds,
    UpdateCartDetail,
    UpdateOverlayDetail,
    UpdateOverlayOptions,
} from 'Common/appshell_types/customEventTypes';

export const EventsListener = (events: Event[], el: HTMLElement | Document = document) => {
    const addEvent = (evtName: EventNames, cb: (e: EventsType[EventNames]) => void) => {
        el.addEventListener(evtName, cb, false);
    };

    const removeEvent = (evtName: EventNames, cb: (e: EventsType[EventNames]) => void) => {
        el.removeEventListener(evtName, cb, false);
    };

    events.forEach(e => addEvent(e.name, e.event));
    return {
        dispose: () => {
            events.forEach(e => removeEvent(e.name, e.event));
        },
    };
};

export const EventDispatcher = (el: HTMLElement | Document = document) => {
    const dispatch = (event: CustomEvent) => {
        el.dispatchEvent(event);
    };

    const create = (name: EventNames, detail: object) => {
        return new CustomEvent(name, detail);
    };

    const updateOverlay = (action: DisplayActions, id: OverlayIds, options?: UpdateOverlayOptions) => {
        const detail: UpdateOverlayDetail = {
            action,
            id,
            options,
        };
        dispatch(create(EventNames.UPDATE_OVERLAYS, { detail }));
    };

    const updateCart = (action: GenericActions, shouldShowCartFlyout: boolean) => {
        const detail: UpdateCartDetail = {
            action,
            shouldShowCartFlyout,
        };
        dispatch(create(EventNames.UPDATE_CART, { detail }));
    };
    return { updateOverlay, updateCart };
};

export default EventsListener;
